module.exports = __webpack_public_path__ + "img/Logo_valentines_day.3b6d60d4.svg";